import { render, staticRenderFns } from "./DeliveryDetails.vue?vue&type=template&id=06007ba7&scoped=true&"
import script from "./DeliveryDetails.vue?vue&type=script&lang=js&"
export * from "./DeliveryDetails.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryDetails.vue?vue&type=style&index=0&id=06007ba7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06007ba7",
  null
  
)

export default component.exports